import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomLeft32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowFitBottomLeft32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 27.003a4 4 0 0 1-4-4v-11.5a1 1 0 1 1 2 0v11.5q.001.27.068.519L23.59 7h-7.244a1 1 0 1 1 0-2h10.657v10.656h-1 1a1 1 0 1 1-2 0h1-1V8.414l-16.52 16.52q.247.068.516.068H20.5a1 1 0 1 1 0 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomLeft32);
